"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MinusThickIcon = undefined;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

var MinusThickIcon = function MinusThickIcon(_ref) {
  var color = _ref.color,
      _ref$height = _ref.height,
      height = _ref$height === undefined ? 24 : _ref$height,
      _ref$width = _ref.width,
      width = _ref$width === undefined ? 24 : _ref$width,
      props = _objectWithoutProperties(_ref, ["color", "height", "width"]);

  return _react2.default.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    height: height,
    width: width
  }, props), _react2.default.createElement("path", {
    fill: color,
    d: "M17.715 13.25H5.885c-.496 0-1.038-.633-1.035-1.262.003-.62.545-1.238 1.035-1.238h11.83c.493 0 1.035.625 1.035 1.25s-.542 1.25-1.035 1.25z"
  }));
};

exports.MinusThickIcon = MinusThickIcon;